module.exports = __webpack_public_path__ + "static/img/JACOB-GRANT.e52661e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JACOB-GRANT.jpg
// module id = zfFv
// module chunks = 0